import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../common/icons/Icon';
import moment from 'moment-timezone';
import Loading from '../../../common/components/Loading';

import { validate, getMostRecentValue } from './profile-utils';

class ProfileHistoryField extends Component {
  static propTypes = {
    action: PropTypes.func,
    editable: PropTypes.bool,
    fieldData: PropTypes.object,
    inputRegex: PropTypes.object,
    placeHolder: PropTypes.string,
    propertyName: PropTypes.string.isRequired,
    showHistory: PropTypes.bool,
    title: PropTypes.string.isRequired,
    toggleShowHistory: PropTypes.func.isRequired,
    validations: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  constructor(props) {
    super(props);
    const { fieldData, propertyName } = props;

    this.state = {
      isEditing: false,
      saving: false,
      editData: null,
      currentRecord: getMostRecentValue(fieldData, propertyName),
      errors: [],
    };
  }

  componentWillReceiveProps = nextProps => {
    const { fieldData, propertyName } = this.props;

    if (nextProps.fieldData !== fieldData) {
      this.setState({
        saving: false,
        isEditing: false,
        editData: null,
        currentRecord: getMostRecentValue(nextProps.fieldData, propertyName),
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const { action, validations } = this.props;
    const { editData } = this.state;
    if (validations) {
      const errors = validate(validations, editData);
      if (errors.length === 0) {
        this.setState({ saving: true }, () => {
          action(editData);
        });
      } else {
        this.setState({ errors: errors });
      }
    } else {
      this.setState({ saving: true }, () => {
        action(editData);
      });
    }
  };

  handleChange = e => {
    const { inputRegex } = this.props;
    const value = inputRegex ? e.currentTarget.value.replace(inputRegex, '') : e.currentTarget.value;

    this.setState({ editData: value });
  };

  toggleEdit = () => {
    const { isEditing, currentRecord } = this.state;
    let stateUpdate = { isEditing: !isEditing };
    if (isEditing) {
      stateUpdate.editData = null;
    } else {
      stateUpdate.editData = currentRecord || 0;
    }
    this.setState(stateUpdate);
  };

  renderHistory = () => {
    const { fieldData, propertyName, title, toggleShowHistory } = this.props;

    return (
      <div className="history-table">
        <div className="modal__content--alt">
          <div className="history-table__wrapper">
            <div className="history-table__header">
              <h4>{`${title} over time`}</h4>
              <button className="close-button" type="button" onClick={toggleShowHistory}>
                <Icon icon="Close" />
              </button>
            </div>
            {fieldData && fieldData.size > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>{title}</th>
                  </tr>
                </thead>
                <tbody>
                  {fieldData.map((item, index) => {
                    return (
                      <tr key={`${propertyName}-row-${index}`}>
                        <td>{moment(item.get('created_at')).format('MM/DD/YYYY')}</td>
                        <td>
                          {item.get(propertyName)} {propertyName === 'distance' ? 'yd' : ''}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="history-empty">
                <p>{`You don't have any data.`}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderEditing = () => {
    const { currentRecord, editData, errors } = this.state;

    return (
      <div className="profile-base-field">
        <div className="profile-text-field editing">
          <form onSubmit={this.handleSubmit}>
            <div className="input-scaffold">
              <input type="text" value={editData} onChange={this.handleChange} />
            </div>
            <div className="actions--wrapper">
              <div className="actions--wrapper__buttons">
                <button className="button button--theme--plain button--small" type="button" onClick={this.toggleEdit}>
                  Cancel
                </button>
                <button className="button button--small" type="submit" disabled={!editData || currentRecord === editData}>
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
        {errors.length > 0 ? (
          <div className="profile-error__wrapper">
            {errors.map((error, index) => {
              return (
                <div className="profile-error--error" key={`error-${index}`}>
                  {error}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  renderNotEditing = () => {
    const { editable, placeHolder, propertyName, showHistory, toggleShowHistory } = this.props;
    const { currentRecord } = this.state;

    return (
      <div className="profile-base-field">
        <div className="profile-history-field">
          <div className={`profile-text-field ${showHistory ? 'showing-history' : ''}`}>
            <span>
              {currentRecord || currentRecord === 0 ? (
                currentRecord + (propertyName === 'distance' ? ' yd' : '')
              ) : (
                placeHolder
              )}
            </span>
            <div className="actions--wrapper__hist-not-editing">
              <button className="profile-text-field__edit-button" type="button" onClick={toggleShowHistory}>
                <Icon icon="History" />
              </button>
              {editable && (
                <button className="profile-text-field__edit-button" type="button" onClick={this.toggleEdit}>
                  <Icon icon="Pencil" />
                </button>
              )}
            </div>
          </div>
          {showHistory && this.renderHistory()}
        </div>
      </div>
    );
  };

  render = () => {
    const { isEditing, saving } = this.state;

    if (saving) return <Loading />;

    return isEditing ? this.renderEditing() : this.renderNotEditing();
  };
}

export default ProfileHistoryField;



// WEBPACK FOOTER //
// ./src/subscription/profile/components/ProfileHistoryField.js